export default __webpack_public_path__ + "static/media/ou-gif.1f87e3aa.gif";